import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

export const link = css`
  font-weight: ${typography.weightSemiBold};
`;
